import { render, staticRenderFns } from "./salePersonLinkAgent.vue?vue&type=template&id=7d2f125d&scoped=true&"
import script from "./salePersonLinkAgent.vue?vue&type=script&lang=js&"
export * from "./salePersonLinkAgent.vue?vue&type=script&lang=js&"
import style0 from "./salePersonLinkAgent.vue?vue&type=style&index=0&id=7d2f125d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f125d",
  null
  
)

export default component.exports